import $http from '../../axios'

export default {

    /* ===========================
       CONECTAR MERCADO LIBRE
    ============================ */

    async connectMercadoLibre({ commit }) {

        try {

            const response = await $http.get('/api/mercadolibre/connect')

            const { url } = response.data

            if (url) {
                window.open(url, '_blank')
                commit('SET_MERCADO_PENDING', true)
            }

        } catch (error) {
            console.error('Error conectando con MercadoLibre', error)
        }

    },


    /* ===========================
       VERIFICAR PRODUCTO
    ============================ */

    async checkMercadoProduct({ commit }, productId) {

        try {

            commit('SET_MERCADO_PRODUCT_STATUS', null)

            const response = await $http.get(
                `/api/mercadolibre/product/check/${productId}`
            )

            commit('SET_MERCADO_PRODUCT_STATUS', response.data)

        } catch (error) {
            console.error('Error consultando producto en MercadoLibre', error)
        }

    },


    /* ===========================
       CARGAR TODAS LAS CATEGORIAS
    ============================ */

    async loadMercadoAllCategories({ commit }) {

        try {

            const response = await $http.get('/api/mercadolibre/categories')

            commit('SET_MERCADO_CATEGORIES', response.data.data)

            return response.data.data

        } catch (error) {
            console.error('Error cargando categorias MercadoLibre', error)
            return []
        }

    },


    /* ===========================
       INFORMACION DE CATEGORIA
    ============================ */

    async getMercadoCategory(_, categoryId) {

        try {

            const response = await $http.get(
                `/api/mercadolibre/categories/${categoryId}`
            )

            return response.data

        } catch (error) {
            console.error('Error cargando informacion de categoria', error)
            return null
        }

    },


    /* ===========================
       ATRIBUTOS DE CATEGORIA
    ============================ */

    async loadMercadoCategoryAttributes({ commit }, categoryId) {

        try {

            commit('RESET_MERCADO_ATTRIBUTES')

            const response = await $http.get(
                `/api/mercadolibre/categories/${categoryId}/attributes`
            )

            commit('SET_MERCADO_CATEGORY_ATTRIBUTES', response.data.data)

            return response.data.data

        } catch (error) {
            console.error('Error cargando atributos MercadoLibre', error)
            commit('SET_MERCADO_CATEGORY_ATTRIBUTES', [])
            return []
        }

    },


    /* ===========================
       PUBLICAR PRODUCTO
    ============================ */

   async publishMercadoProduct({ commit, dispatch }, { productId, payload }) {

    commit('SET_MERCADO_PUBLISHING', true)
    commit('SET_MERCADO_PUBLISH_ERROR', null)

    try {

        const response = await $http.post(
            '/api/mercadolibre/product/publish',
            {
                product_id:              productId,
                category_id:             payload.category_id,
                listing_type:            payload.listing_type            || 'bronze',
                condition:               payload.condition               || 'new',
                price:                   payload.price                   || null,
                price_is_custom:         payload.price_is_custom         || false,
                price_list_id:           payload.price_list_id           || null,
                quantity:                payload.quantity                || null,
                title:                   payload.title                   || null,
                attributes:              payload.attributes              || [],
                selected_attachment_ids: payload.selected_attachment_ids || [],
            }
        )

        await dispatch('checkMercadoProduct', productId)
        commit('SET_MERCADO_INCIDENT', null)

        return response.data

    } catch (error) {

        const data    = error.response && error.response.data ? error.response.data : {}
        const message = data.message || 'Error publicando en MercadoLibre'
        const cause   = data.cause   || []

        commit('SET_MERCADO_PUBLISH_ERROR', { message, cause })

        console.error('[ML] Error publicando producto', data)

        throw error

    } finally {

        commit('SET_MERCADO_PUBLISHING', false)

    }

},

    /* ===========================
   TIPOS DE PUBLICACION
============================ */

async loadMercadoListingTypes({ commit, state }) {

    if (state.mercadoListingTypes && state.mercadoListingTypes.length) {
        return state.mercadoListingTypes
    }

    try {

        const response = await $http.get('/api/mercadolibre/listing-types')

        commit('SET_MERCADO_LISTING_TYPES', response.data.data)

        return response.data.data

    } catch (error) {

        console.error('Error cargando tipos de publicación ML', error)
        return []

    }

},

/* ===========================
   ITEMS DISPONIBLES PARA VINCULAR
============================ */

async loadAvailableItems({ commit }, { productId, page, limit, search }) {

    commit('SET_MERCADO_AVAILABLE_ITEMS_LOADING', true)

    try {

        const response = await $http.get(
            '/api/mercadolibre/product/' + productId + '/available-items',
            { params: { page: page || 1, limit: limit || 20, search: search || '' } }
        )

        commit('SET_MERCADO_AVAILABLE_ITEMS', response.data.data)
        commit('SET_MERCADO_AVAILABLE_ITEMS_PAGING', response.data.paging)

        return response.data

    } catch (error) {

        console.error('Error cargando items disponibles ML', error)
        return { data: [], paging: {} }

    } finally {

        commit('SET_MERCADO_AVAILABLE_ITEMS_LOADING', false)

    }

},


/* ===========================
   VINCULAR ITEM EXISTENTE
============================ */

async linkMercadoItem({ commit, dispatch }, { productId, mlItemId }) {

    try {

        const response = await $http.post(
            '/api/mercadolibre/product/' + productId + '/link',
            { ml_item_id: mlItemId }
        )

        await dispatch('checkMercadoProduct', productId)

        return response.data

    } catch (error) {

        const data    = error.response && error.response.data ? error.response.data : {}
        const message = data.message || 'Error vinculando publicación'

        commit('SET_MERCADO_PUBLISH_ERROR', { message, cause: [] })

        throw error

    }

},


/* ===========================
   OBTENER ITEM VINCULADO (para edicion)
============================ */

async loadLinkedItem({ commit }, productId) {

    commit('SET_MERCADO_LINKED_ITEM_LOADING', true)

    try {

        const response = await $http.get(
            '/api/mercadolibre/product/' + productId + '/item'
        )

        commit('SET_MERCADO_LINKED_ITEM', response.data.data)

        return response.data.data

    } catch (error) {

        console.error('Error cargando item vinculado ML', error)
        return null

    } finally {

        commit('SET_MERCADO_LINKED_ITEM_LOADING', false)

    }

},


/* ===========================
   ACTUALIZAR ITEM VINCULADO
============================ */

async updateLinkedItem({ commit, dispatch }, { productId, payload }) {

    commit('SET_MERCADO_PUBLISHING', true)
    commit('SET_MERCADO_PUBLISH_ERROR', null)

    try {

        const response = await $http.put(
            '/api/mercadolibre/product/' + productId + '/item',
            payload
        )

        await dispatch('checkMercadoProduct', productId)

        return response.data

    } catch (error) {

        const data    = error.response && error.response.data ? error.response.data : {}
        const message = data.message || 'Error actualizando publicación'
        const cause   = data.cause   || []

        commit('SET_MERCADO_PUBLISH_ERROR', { message, cause })

        throw error

    } finally {

        commit('SET_MERCADO_PUBLISHING', false)

    }

},

/* ===========================
   PAUSAR ITEM
============================ */
async pauseMercadoItem({ dispatch }, productId) {
    await $http.put('/api/mercadolibre/product/' + productId + '/item/pause')
    await dispatch('checkMercadoProduct', productId)
},

/* ===========================
   REACTIVAR ITEM
============================ */
async activateMercadoItem({ dispatch }, productId) {
    await $http.put('/api/mercadolibre/product/' + productId + '/item/activate')
    await dispatch('checkMercadoProduct', productId)
},

/* ===========================
   ELIMINAR ITEM
============================ */
async deleteMercadoItem({ dispatch }, productId) {
    await $http.delete('/api/mercadolibre/product/' + productId + '/item')
    await dispatch('checkMercadoProduct', productId)
},

async fetchMlTransfers({ commit, state }) {
    commit('SET_ML_TRANSFERS_LOADING', true)
    try {
        const response = await $http.get('/api/mercadolibre/transfers', {
            params: state.mlTransfersParams
        })
        commit('SET_ML_TRANSFERS', response.data.data)
    } catch (error) {
        console.error('Error cargando traslados ML', error)
    } finally {
        commit('SET_ML_TRANSFERS_LOADING', false)
    }
},

async updateMlTransfer({ commit }, { id, physicalTransfer }) {
    try {
        await $http.put(`/api/mercadolibre/transfers/${id}`, {
            physical_transfer: physicalTransfer
        })
        return true
    } catch (error) {
        console.error('Error actualizando traslado ML', error)
        return false
    }
},

/* ===========================
   DESVINCULAR ITEM (sin cerrar en ML)
============================ */
async unlinkMercadoItem({ dispatch }, productId) {
    await $http.delete('/api/mercadolibre/product/' + productId + '/unlink')
    await dispatch('checkMercadoProduct', productId)
},

/* ===========================
   TRANSFERIR VINCULO A OTRO ITEM
============================ */
async transferMercadoLink({ commit, dispatch }, { productId, mlItemId }) {

    try {

        const response = await $http.post(
            '/api/mercadolibre/product/' + productId + '/transfer-link',
            { ml_item_id: mlItemId }
        )

        await dispatch('checkMercadoProduct', productId)

        return response.data

    } catch (error) {

        const data    = error.response && error.response.data ? error.response.data : {}
        const message = data.message || 'Error transfiriendo publicación'

        commit('SET_MERCADO_PUBLISH_ERROR', { message, cause: [] })

        throw error

    }

},

}




// WEBPACK FOOTER //
// ./src/modules/mercado-api/actions.js